import { EMAIL_REGEX } from 'utils/regex';

/** Allowed URI schemes, in lowercase with semicolon at the end */
const SAFE_SCHEMES = ['https:', 'http:', 'mailto:', 'tel:', 'sms:'];

const getDefaultWebLinkSchemeIfMissing = (link: string) => {
  const hasUriSchemeRegex = /^[a-z][\w+\-.]*:/i;
  const hasUriScheme = hasUriSchemeRegex.test(link);

  return hasUriScheme ? '' : 'https://';
};

/** Renders <a> element if the link is safe or returns null if the link is unsafe */
export const renderLinkSafelyOrNull = (link: string, isPhoneOrEmail: boolean) => {
  const type = isPhoneOrEmail ? (EMAIL_REGEX.test(link) ? 'mailto:' : 'tel:') : getDefaultWebLinkSchemeIfMissing(link);

  const schemeProvidedByUser = type === '';
  if (!isPhoneOrEmail && schemeProvidedByUser) {
    const schemeMatch = link.match(/^([a-z][\w+\-.]*:)/i);
    if (schemeMatch?.[1] && !SAFE_SCHEMES.includes(schemeMatch[1].toLowerCase())) {
      // Unsafe scheme !!! Do not return link !!!
      return null;
    }
  }

  return (
    <a
      href={`${type}${link}`}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
      style={{ color: 'inherit', textDecoration: 'none' }}>
      {link}
    </a>
  );
};
